import React, { useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { months } from "../helpers/constants";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function MultipleSelectChip({ inputHandler2, selectedMonths }) {
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);
  useEffect(() => {
    const monthsArr = [];
    const selectedMonthsArr = selectedMonths
      ? selectedMonths.split(",").map((item) => Number(item))
      : [];
    months.forEach((item, i) => {
      let index = selectedMonthsArr.indexOf(item.id);
      if (index > -1) {
        monthsArr.push(months[i].name);
      }
    });
    setPersonName(monthsArr);
  }, [selectedMonths]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  return (
    <div>
      <FormControl sx={{ my: 1, mb:2, width: "100%"}}>
        <InputLabel id="demo-multiple-chip-label">Select Months</InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={personName}
          onChange={(e) => {
            handleChange(e);
            inputHandler2(e.target.value);
          }}
          input={
            <OutlinedInput id="select-multiple-chip" label="Select Months" />
          }
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {months.map((name) => (
            <MenuItem
              key={name.name}
              value={name.name}
              style={getStyles(name.name, personName, theme)}
            >
              {name.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
